"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationLoggerStringMap = exports.InternalNavigationType = exports.BeatEventType = void 0;
var BeatEventType;
(function (BeatEventType) {
    BeatEventType[BeatEventType["START"] = 1] = "START";
    BeatEventType[BeatEventType["VISIBLE"] = 2] = "VISIBLE";
    BeatEventType[BeatEventType["PAGE_FINISH"] = 33] = "PAGE_FINISH";
    BeatEventType[BeatEventType["FIRST_CDN_RESPONSE"] = 4] = "FIRST_CDN_RESPONSE";
    BeatEventType[BeatEventType["TBD"] = -1] = "TBD";
    BeatEventType[BeatEventType["PAGE_NAVIGATION"] = 101] = "PAGE_NAVIGATION";
    BeatEventType[BeatEventType["PAGE_NAVIGATION_DONE"] = 103] = "PAGE_NAVIGATION_DONE";
})(BeatEventType = exports.BeatEventType || (exports.BeatEventType = {}));
var InternalNavigationType;
(function (InternalNavigationType) {
    InternalNavigationType[InternalNavigationType["NAVIGATION"] = 1] = "NAVIGATION";
    InternalNavigationType[InternalNavigationType["DYNAMIC_REDIRECT"] = 2] = "DYNAMIC_REDIRECT";
    InternalNavigationType[InternalNavigationType["INNER_ROUTE"] = 3] = "INNER_ROUTE";
    InternalNavigationType[InternalNavigationType["NAVIGATION_ERROR"] = 4] = "NAVIGATION_ERROR";
    InternalNavigationType[InternalNavigationType["CANCELED"] = 5] = "CANCELED";
})(InternalNavigationType = exports.InternalNavigationType || (exports.InternalNavigationType = {}));
exports.NavigationLoggerStringMap = {
    // map between InternalNavigationType to fed ops logger string
    1: 'page-navigation',
    2: 'page-navigation-redirect',
    3: 'page-navigation-inner-route',
    4: 'navigation-error',
    5: 'navigation-canceled', // unnecessary navigation canceled
};
//# sourceMappingURL=bi-types.js.map